import axios from "axios";

export const state = {
    reportinactivemembers: [],
};

export const getters = {
    reportinactivemembers: state => state.reportinactivemembers,
};

export const mutations = {
    setReportInactiveMembers(reportinactivemembers, newValue) { state.reportinactivemembers = newValue},
};

export const actions = {
    async fetchReportInactiveMembers({ commit }) {
        await axios.get('/reportinactivemembers').then(res => {
            commit('setReportInactiveMembers', res.data.members)
        })
    },
    async filterReportInactiveMembers({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportinactivemembers";
        await axios.post(url, formData).then((response) => {
            commit('setReportInactiveMembers', response.data.members)
        })
    },
};
